import { memo, useRef } from 'react';
import { useDragLayer } from 'react-dnd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var DragLayerWrapper = styled.div.withConfig({
  displayName: "custom-drag-layer__DragLayerWrapper",
  componentId: "sc-ig17ow-0"
})(["position:fixed;pointer-events:none;z-index:9999;left:0;top:0;width:100%;height:100%;"]);
var DragPreviewItem = styled.div.withConfig({
  displayName: "custom-drag-layer__DragPreviewItem",
  componentId: "sc-ig17ow-1"
})(["display:flex;align-items:center;gap:8px;padding:10px 12px;min-width:220px;max-width:320px;background:#ffffff;border:1px solid #91caff;border-left:3px solid #1677ff;border-radius:8px;box-shadow:0 8px 24px rgba(15,23,42,0.16),0 2px 6px rgba(15,23,42,0.08);opacity:0.96;font-size:13px;line-height:1.35;color:#0f172a;transform:rotate(1.5deg);"]);
var PreviewLabel = styled.span.withConfig({
  displayName: "custom-drag-layer__PreviewLabel",
  componentId: "sc-ig17ow-2"
})(["flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);

/**
 * Updates position imperatively so pointer moves do not re-render React.
 * useDragLayer only re-renders when isDragging / item identity changes.
 */
export var CustomDragLayer = /*#__PURE__*/memo(function () {
  var previewRef = useRef(null);

  var _useDragLayer = useDragLayer(function (monitor) {
    var offset = monitor.getSourceClientOffset();
    var node = previewRef.current;

    if (node && offset) {
      node.style.transform = "translate3d(".concat(offset.x, "px, ").concat(offset.y, "px, 0)");
    }

    return {
      item: monitor.getItem(),
      isDragging: monitor.isDragging(),
      currentOffset: node ? null : offset
    };
  }),
      isDragging = _useDragLayer.isDragging,
      item = _useDragLayer.item,
      currentOffset = _useDragLayer.currentOffset;

  if (!isDragging) {
    return null;
  }

  var initialTransform = currentOffset ? "translate3d(".concat(currentOffset.x, "px, ").concat(currentOffset.y, "px, 0)") : undefined;
  return /*#__PURE__*/_jsx(DragLayerWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      ref: previewRef,
      style: {
        transform: initialTransform,
        willChange: 'transform'
      },
      children: /*#__PURE__*/_jsx(DragPreviewItem, {
        children: /*#__PURE__*/_jsx(PreviewLabel, {
          children: (item === null || item === void 0 ? void 0 : item.title) || (item !== null && item !== void 0 && item.id ? "Question ".concat(item.id) : 'Moving question')
        })
      })
    })
  });
});
CustomDragLayer.displayName = 'CustomDragLayer';